import React from 'react';
import styled from 'styled-components';

import { AppConfigProvider } from '../../../context/app-config-context';
import { TabManagerProvider } from '../../../context/tab-manager-context';
import Sidebar from '../../sidebar';

import { AppCore } from './AppCore';
import { PanelLayoutV3 } from './PanelLayoutV3';

const LayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
`;

const SidebarContainer = styled.div`
  flex-shrink: 0;
  height: 100%;
`;

const PanelContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  overflow: hidden;
`;

/**
 * LayoutV3 - Multi-tab architecture layout
 * Wraps TabManagerProvider around Sidebar and PanelLayoutV3
 * Sidebar needs access to TabManagerContext to create tabs on menu clicks
 *
 * Layout structure:
 * - AppCore: URL routing controller (renders nothing, handles URL → State)
 * - Left: Sidebar (fixed width)
 * - Right: PanelLayoutV3 (flexible, contains TabContainerV3, SidePanel, and MainTabContent)
 */
export const LayoutV3: React.FC = () => {
  return (
    <AppConfigProvider>
      <TabManagerProvider>
        {/* AppCore handles URL-based routing decisions */}
        <AppCore />
        <LayoutContainer>
          <SidebarContainer>
            <Sidebar />
          </SidebarContainer>
          <PanelContainer>
            <PanelLayoutV3 />
          </PanelContainer>
        </LayoutContainer>
      </TabManagerProvider>
    </AppConfigProvider>
  );
};
